"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Field = require("./formField");
const text_1 = require("./text");
class HourMinuteComponent extends React.PureComponent {
    render() {
        const props = this.props;
        // const maxMinutes = props.hours && props.max ? Math.min(59, (props.max - props.hours) * 60) : 59;
        return (React.createElement("div", { style: { display: "flex" } },
            React.createElement("div", { style: { flex: "1 0 0" } },
                React.createElement(text_1.Text, { readonly: props.readonly, value: props.hours + "", onChange: (x) => this.props.onChange({ hours: x, minutes: this.props.minutes }), disableFastInput: true })),
            React.createElement("div", { style: { flex: "1 0 0" } },
                React.createElement(text_1.Text, { readonly: props.readonly, value: props.minutes + "", onChange: (x) => this.props.onChange({ hours: this.props.hours, minutes: x }), disableFastInput: true }))));
    }
}
exports.HourMinuteComponent = HourMinuteComponent;
class Hours extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value) => {
            var horas = value.hours;
            var horatomada = parseInt(horas || "0");
            var minutos = value.minutes;
            var minutotomado = parseInt(minutos || "0");
            if (minutotomado > 59) {
                var nuevosminutos = minutos.substring(0, 2);
                minutotomado = parseInt(nuevosminutos);
            }
            const hours = horatomada;
            const minutes = minutotomado >= 60 ? 59 : minutotomado;
            if (this.props.onChange) {
                this.props.onChange(((hours || 0) + ((minutes || 0) / 60.0)));
            }
        };
    }
    render() {
        const value = this.props.value;
        const hours = ((value != null) && (value < 0 ? Math.ceil(value) : Math.floor(value))) || 0;
        const minutes = ((value != null) && (hours != null) && Math.round(value * 60 - hours * 60)) || 0;
        return (React.createElement(Field.FormField, { label: this.props.label, error: this.props.error },
            React.createElement(HourMinuteComponent, { hours: hours > 9 ? hours + "" : "0" + hours, minutes: minutes > 9 ? minutes + "" : "0" + minutes, onChange: this.handleOnChange, readonly: this.props.readonly, min: this.props.min || 0, max: this.props.max || 24 })));
    }
}
exports.Hours = Hours;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/fields/hour.js
// module id = 500
// module chunks = 0